<template>
  <b-modal
    id="createUserPopup"
    :title="isEditing ? 'アカウント編集' : 'アカウント新規追加'"
    size="lg"
    ref="createUserPopup"
    @hide="hideModal"
    @show="showModal"
    hide-footer
  >
    <div class="main-container">
      <Loader v-show="loading" />
      <div
        class="w-100 row no-gutters main-area inner-form-section"
        style="background: none;box-shadow: none;"
        v-show="!loading"
      >
        <div class="col-md-12 col-form-section">
          <div class="form-section">
            <!-- <p>新規ユーザーの設定</p> -->
            <div class="form-detail">
              <form v-on:submit.prevent="createUser">
                <input
                  type="hidden"
                  name="password_method"
                  value="is_activation_link"
                />
                <div class="form-detail-block">
                  <div class="custom-form-block">
                    <div class="form-group">
                      <div class="row mb-4">
                        <label class="col-md-3 col-form-label"
                          >アカウント名（必須）</label
                        >
                        <div class="col-md-9">
                          <input
                            type="text"
                            class="form-control is-valid"
                            name="name"
                            v-bind:class="{ 'is-invalid': hasError('name') }"
                            v-model="name"
                            v-validate="'required|max:50'"
                            data-vv-as="名前"
                          />
                          <div class="invalid-feedback" v-if="hasError('name')">
                            <span class="icon-error">!</span
                            >{{ getErrorMessage('name') }}
                          </div>
                        </div>
                      </div>
                      <div class="row mb-4">
                        <label class="col-md-3 col-form-label"
                          >メールアドレス（必須）
                        </label>
                        <div class="col-md-9">
                          <input
                            type="email"
                            class="form-control is-valid"
                            name="email"
                            v-model="email"
                            v-bind:class="{ 'is-invalid': hasError('email') }"
                            v-validate="'required'"
                            data-vv-as="メールアドレス"
                            :readonly="isEditing"
                          />
                          <div
                            class="invalid-feedback"
                            v-if="hasError('email')"
                          >
                            <span class="icon-error">!</span
                            >{{ getErrorMessage('email') }}
                          </div>
                        </div>
                      </div>

                      <div class="row mb-4">
                        <label
                          class="col-md-3 col-form-label"
                          style="text-transform: none;"
                          >区分</label
                        >
                        <div class="col-md-9">
                          <div class="form-check mb-4">
                            <label class="form-check-label mb-2 ml-3 info-label"
                              >※人事アカウントは登録者全体を閲覧できます</label
                            >
                            <label class="form-check-label mb-2 ml-3 info-label"
                              >※部門アカウントは閲覧権限を設定した登録者しか閲覧できません</label
                            >
                            <input
                              type="radio"
                              value="true"
                              name="parentRadio"
                              v-model="parentRadio"
                              class="form-check-input"
                            />
                            <label class="form-check-label mb-2 ml-3 font-normal"
                              >人事
                            </label>
                            <p class="ml-3">
                              管理画面利用アカウント追加・削除の権限を付与しますか？
                            </p>
                            <div class="nested-radio ml-4">
                              <label class="form-check-label d-block mr-3 mb-3 font-normal">
                                <input
                                  type="radio"
                                  name="admin"
                                  value="true"
                                  v-model="admin"
                                  :disabled="reviewer === 'true'"
                                />
                                はい
                              </label>
                              <label class="form-check-label d-block font-normal">
                                <input
                                  type="radio"
                                  name="admin"
                                  value="false"
                                  v-model="admin"
                                  :disabled="reviewer === 'true'"
                                />
                                いいえ
                              </label>
                            </div>
                          </div>
                          <div class="form-check mb-2">
                            <input
                              type="radio"
                              name="reviewer"
                              v-model="reviewer"
                              value="true"
                              class="form-check-input"
                            />
                            <label class="form-check-label ml-3">部門</label>
                          </div>
                          <div
                            class="invalid-feedback mt-2"
                            v-if="hasError('admin')"
                            style="text-align: center; justify-content:left"
                          >
                            <span class="icon-error">!</span
                            >{{ getErrorMessage('admin') }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- ends custom-form-block -->
                </div>
                <!-- ends form-detail-block -->
                <div
                  class="btn-toolbar justify-content-center ml-4"
                  role="toolbar"
                  aria-label="Toolbar with button groups"
                >
                  <button
                    @click="hideModal"
                    id="users"
                    class="btn btn-rounded-plain mr-4"
                  >
                    キャンセル
                  </button>
                  <button
                    class="btn btn-primary btn-rounded"
                    type="submit"
                    v-html="saveText"
                  ></button>
                </div>
              </form>
            </div>
            <!-- ends form-detail -->
          </div>
          <!-- ends form-section -->
        </div>
      </div>
      <!-- ends main-area -->
    </div>
  </b-modal>
</template>
<script>
import Api from '@/config/api';
import ApiService from '@/service/apiService';
import { mapMutations, mapGetters, mapActions } from 'vuex';
import Loader from '@/components/utils/Loader.vue';

export default {
  name: 'CreateUser',
  components: { Loader },
  props: {
    isEditing: {
      type: Boolean,
      required: true,
    },
    user: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      name: '',
      email: '',
      admin: null,
      reviewer: 'true',
      parentRadio: null,
      isUserAdmin: '',
      hasContactAuthority: '',
      isContactDisabled: false,
      contact: false,
      password: '',
      password_confirmation: '',
      serverErrors: {},
      loading: false,
    };
  },
  async mounted() {
    this.$refs.createUserPopup.show();
  },
  computed: {
    ...mapGetters({
      isAdmin: 'currentUserIsAdmin',
      currentUser: 'getCurrentUser',
      getUsers: 'getUsers',
    }),
    hasIndividualContactAuthority() {
      return this.currentUser && this.currentUser.companyContactAuthority;
    },
    checkToDisable() {
      if (this.admin) {
        return true;
      } else {
        return false;
      }
    },
    saveText() {
      return this.isEditing ? '上書き保存' : '追加する';
    },
    data() {
      return {
        name: this.name,
        email: this.email,
        isAdmin: this.admin === null ? 'false' : this.admin,
        isCreateReviewUser: this.reviewer === null ? 'true' : 'false',
        individualContactAuthority: !this.hasIndividualContactAuthority
          ? 'false'
          : this.contact,
        // password: this.password,
        // confirm_password: this.password_confirmation,
        password_method: 'is_activation_link',
      };
    },
  },
  methods: {
    ...mapMutations({
      setUser: 'setUser',
      updateUserList: 'updateUserList',
      updateReviewListUsers: 'updateReviewListUsers',
    }),
    ...mapActions({
      loadUsers: 'loadUsers',
      loadCurrentUser: 'loadCurrentUser',
    }),
    hideModal() {
      this.$emit('hideModal');
    },
    showModal() {
      this.$refs.createUserPopup.show();
    },
    hasError(field) {
      return (
        field in this.serverErrors || this.formErrors.first(field) !== undefined
      );
    },
    getErrorMessage(field) {
      if (this.formErrors.first(field) !== undefined)
        return this.formErrors.first(field);
      else if (field in this.serverErrors) return this.serverErrors[field].msg;
      return '';
    },
    async createUser() {
      const check = await this.$validator.validate();
      if (check) {
        this.loading = true;

        let endpoint;
        if (this.isEditing) {
          endpoint = Api.endpoints.EDITUSER(this.user.id);
        } else {
          endpoint = `${Api.endpoints.CREATEUSER}?isNewPanel=true`;
        }

        ApiService.post(endpoint, this.data) // eslint-disable-next-line
          .then(({ data }) => {
            // this.setUser(data.data);
            this.updateReviewListUsers(data.data);
            this.updateUserList(data.data);
            this.loading = false;
            this.hideModal();
            // this.$router.push({ path: '/setting/users' });
          })
          .catch((error) => {
            this.loading = false;
            if (error.response.status === 422) {
              this.serverErrors = error.response.data;
            } else {
              this.parseErrorResponse(error.response);
            }
          });
      }
    },
  },
  async created() {
    if (this.isEditing) {
      // if (this.getUsers && !this.getUsers.length) {
      //   await this.loadUsers();
      // }
      // const id = this.$route.params.id;
      // const user = this.getUsers.find((user) => user.id === id);
      this.name = this.user.name;
      this.email = this.user.email;
      this.isUserAdmin = this.user.isAdmin;
      this.hasContactAuthority = this.user.userContactAuthority;

      this.parentRadio =
        this.user.isAdmin || this.user.isCreateReviewUser ? 'true' : undefined;
      this.admin = this.user.isAdmin
        ? 'true'
        : this.user.isCreateReviewUser
        ? 'false'
        : undefined;
      this.reviewer =
        !this.user.isAdmin && !this.user.isCreateReviewUser
          ? 'true'
          : undefined;
      this.contact = this.user.userContactAuthority
        ? 'true'
        : this.user.isAdmin
        ? 'true'
        : 'false';
    }
  },
  watch: {
    // admin: function(val) {
    //   if (val==="true") {
    //     // If isAdmin is checked, set isReviewer to checked and disable the button
    //     this.reviewer = true;
    //   }else{
    //     this.reviewer = false;
    //   }
    // },
    reviewer: function(val) {
      if (val === 'true') {
        this.parentRadio = this.admin = null;
      }
    },
    parentRadio: function(val) {
      if (val === 'true') {
        this.reviewer = null;
        this.admin = this.isUserAdmin ? 'true' : 'false';
      }
    },
    admin: function(val) {
      if (val === 'true') {
        this.contact = 'true';
        this.isContactDisabled = true;
      } else {
        this.isContactDisabled = false;
      }
      // this.contact = (val === 'true') ? 'true' : 'false';
    },
  },
};
</script>

<style scoped>
.font-normal {
  font-weight: normal !important;
}
/* Style for readonly input */
.custom-form-block .form-control.is-valid {
  background: none;
}
.info-label {
  display: block;
  color: #ff0000;
  font-weight: 400 !important;
  margin-left: -20px !important;
}

.btn.btn-primary {
  width: 165px;
  height: 50px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0px;
}

.custom-form-block .form-control {
  border: 2px solid #3c3c3c !important;
  padding: 0px 10px;
}

input[readonly] {
  background-color: #e9ecef;
  opacity: 1;
}
.inner-form-section {
  margin-left: auto;
  margin-right: auto;
}

p {
  color: #3c3c3c;
  /* font-weight: bold; */
}

.inner-form-section .form-detail {
  max-height: 100%;
}

.form-detail-block {
  border: none;
}

.form-check-inline .form-check-input {
  position: static;
  margin-top: 0;
  margin-right: 0.3125rem;
  margin-left: 0;
}

.btn-rounded-plain {
  background-color: #797978 !important;
  color: #fff !important;
}

.btn-rounded-plain:hover {
  background-color: #666 !important;
}
</style>
